import cnSwiper from '../../../home24-shared/components/quickview/constants/classNames-swiper';
import { getArticleData } from '../../../home24-shared/components/quickview/functions/getArticleData';
import {
  getRecommendationsData,
  isRecommendationsResponseDYO,
  trackDYORecommendations
} from '../../../home24-shared/components/quickview/functions/recommendations';
import { renderRecommendations } from '../../../home24-shared/components/quickview/functions/renderer';
import { attachInhouseRecommendationsTracking } from '../../../home24-shared/components/quickview/functions/eventListeners/recommendations';
import { addAllListener } from './functions/addAllListeners';
import { initalRender } from './functions/render/render';
import {
  alternativeDIVprovider,
  alternativeDIV2Provider,
  pushQvDisplayedEvent
} from '../../../home24-shared/components/quickview/functions/helpers/helpers';
import { lngprovider } from '../../../home24-shared/components/quickview/constants/languages';

export function quickview() {
  const articleData = getArticleData();
  if (Object.keys(articleData).length === 0) {
    return;
  }

  const translations = lngprovider(articleData.lngcode);
  pushQvDisplayedEvent(articleData);
  initalRender(
    articleData,
    `.${cnSwiper.WRAP}`,
    alternativeDIVprovider(),
    alternativeDIV2Provider()
  );
  addAllListener(articleData);
  getRecommendationsData(articleData.smp, articleData.lngcode)
    .then(data => {
      if (data !== null) {
        // no slider hence neither we render it nor track
        renderRecommendations(
          translations.RECOMMENDATIONS_HEADLINE,
          data,
          '.js-quick-view',
          4,
          16
        );

        isRecommendationsResponseDYO(data)
          ? trackDYORecommendations()
          : attachInhouseRecommendationsTracking();
      }
    })
    .catch(err => {
      console.error(err);
    });
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/components/quickview/desktop.js
 **/